import {VariantColors} from './constants';
import {TagVariantType} from './types';

export const getColors = (variant: TagVariantType) => VariantColors[variant];
